import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowExpandHor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-expand-hor"} maskId="square-filled-radius-0-stroke-1-IconArrowExpandHor"><path fillRule="evenodd" clipRule="evenodd" d="M7.20718 8.00008L3.7072 11.5H20.293L16.793 8.00008L17.5001 7.29297L22.2072 12.0001L17.5001 16.7072L16.793 16.0001L20.293 12.5H3.70717L7.20718 16.0001L6.50007 16.7072L1.79297 12.0001L6.50008 7.29297L7.20718 8.00008Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowExpandHor;
